import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from "react";
import { Button } from "./ui/button";
export default function ListItem(t0) {
  const $ = _c(8);
  let active;
  let props;
  if ($[0] !== t0) {
    ({
      active,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = active;
    $[2] = props;
  } else {
    active = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== props) {
    t1 = <li {...props}>{props.children}</li>;
    $[3] = props;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== active || $[6] !== t1) {
    t2 = <Button asChild={true} className="data-[active=true]:text-active hover:text-active w-full cursor-pointer items-center justify-start pb-4 wrap-break-word last-of-type:pb-0" data-active={active} aria-selected={active} variant="link" size="noPadding">{t1}</Button>;
    $[5] = active;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}